module.exports = __webpack_public_path__ + "static/img/1.4eb92f8e.png";